import { mixed, object, string } from 'yup';

import { RegexUtils } from '../regex-utils';

export const addressValidations = {
  addressCountryString: object().shape({
    addressLine1: string()
      .required('Please enter an address')
      .matches(RegexUtils.charsWithHyphenSpaceCommaslash, 'Please enter valid address')
      .max(100, 'Character length exceeded')
      .trim(),

    addressLine2: string()
      .test('addressLine2-test', 'Please enter valid address', (value) => {
        if (!value || value.trim().length === 0) {
          return true;
        }

        return RegexUtils.charsWithHyphenSpaceCommaslash.test(value) && value.length <= 100;
      })
      .max(100, 'Character length exceeded')
      .nullable(),

    country: string().typeError('Please select country').required('Please select country'),

    county: string()
      .test('county-test', 'Please enter valid address', (value) => {
        if (!value || value.trim().length === 0) {
          return true;
        }

        return RegexUtils.alphaNumUTF8SpaceSpecialCharsNoNumbersRegex.test(value) && value.length <= 100;
      })
      .max(100, 'Character length exceeded')
      .notRequired()
      .typeError('Please enter valid address')
      .trim(),

    city: string()
      .required('Please enter a city')
      .matches(RegexUtils.alphaNumUTF8SpaceSpecialCharsNoNumbersRegex, 'City should not have numbers')
      .max(100, 'Character length exceeded')
      .trim(),

    postalCode: string().when('country', (country, schema) => {
      if (Array.isArray(country)) {
        return schema
          .matches(RegexUtils.postalCodeCountriesRegex[country[0]?.value || country[0]?.code || 'UK'], 'Please enter a valid postcode')
          .required('Postal Code is required');
      }

      return schema
        .matches(RegexUtils.postalCodeCountriesRegex[country?.value || country?.code || 'UK'], 'Please enter a valid postcode')
        .required('Please enter a postcode');
    }),
  }),

  businessAddress: object().shape({
    addressLine1: string()
      .required('Please enter an address')
      .matches(RegexUtils.charsWithHyphenSpaceCommaslash, 'Please enter valid address')
      .max(100, 'Character length exceeded')
      .trim(),

    addressLine2: string()
      .test('addressLine2-test', 'Please enter valid address', (value) => {
        if (!value || value.trim().length === 0) {
          return true;
        }

        return RegexUtils.charsWithHyphenSpaceCommaslash.test(value) && value.length <= 100;
      })
      .max(100, 'Character length exceeded')
      .nullable(),

    country: string().typeError('Please select country').required('Please select country'),

    county: string()
      .test('county-test', 'Please enter valid address', (value) => {
        if (!value || value.trim().length === 0) {
          return true;
        }

        return RegexUtils.alphaNumUTF8SpaceSpecialCharsNoNumbersRegex.test(value) && value.length <= 100;
      })
      .max(100, 'Character length exceeded')
      .notRequired()
      .typeError('Please enter valid address')
      .trim(),

    city: string()
      .required('Please enter a city')
      .matches(RegexUtils.alphaNumUTF8SpaceSpecialCharsNoNumbersRegex, 'City should not have numbers')
      .max(100, 'Character length exceeded')
      .trim(),

    postcode: string().when('country', (country, schema) => {
      if (Array.isArray(country)) {
        return schema
          .matches(RegexUtils.postalCodeCountriesRegex[country[0]?.value || country[0]?.code || 'UK'], 'Please enter a valid postcode')
          .required('Postal Code is required');
      }

      return schema
        .matches(RegexUtils.postalCodeCountriesRegex[country?.value || country?.code || 'UK'], 'Please enter a valid postcode')
        .required('Please enter a postcode');
    }),
  }),

  organisationAddress: object().shape({
    addressLine1: string().required('Please enter an address').trim(),

    country: string().required('Please select country'),

    city: string().required('Please enter a city').trim(),
  }),

  addressCountryStringNotRequired: object()
    .shape({
      addressLine1: string().trim().notRequired(),

      addressLine2: string().nullable().notRequired(),

      country: string().notRequired(),

      county: string().trim().notRequired(),

      city: string().trim().notRequired(),

      postalCode: string().notRequired(),
    })
    .notRequired(),

  address: object().shape({
    addressLine1: string()
      .required('Please enter an address')
      .matches(RegexUtils.charsWithHyphenSpaceCommaslash, 'Please enter valid address')
      .max(100, 'Character length exceeded')
      .trim(),

    addressLine2: string()
      .test('addressLine2-test', 'Please enter valid address', (value) => {
        if (!value || value.trim().length === 0) {
          return true;
        }

        return RegexUtils.charsWithHyphenSpaceCommaslash.test(value) && value.length <= 100;
      })
      .max(100, 'Character length exceeded')
      .nullable(),

    country: string().typeError('Please select country').required('Please select country'),

    county: string()
      .test('county-test', 'Please enter valid address', (value) => {
        if (!value || value.trim().length === 0) {
          return true;
        }

        return RegexUtils.alphaNumUTF8SpaceSpecialCharsNoNumbersRegex.test(value) && value.length <= 100;
      })
      .max(100, 'Character length exceeded')
      .notRequired()
      .typeError('Please enter valid address')
      .trim(),

    city: string()
      .required('Please enter a city')
      .matches(RegexUtils.alphaNumUTF8SpaceSpecialCharsNoNumbersRegex, 'City should not have numbers')
      .max(100, 'Character length exceeded')
      .trim(),

    postalCode: string().when('country', (country, schema) => {
      if (Array.isArray(country)) {
        return schema
          .matches(RegexUtils.postalCodeCountriesRegex[country[0]?.value || country[0]?.code || 'UK'], 'Please enter a valid postcode')
          .required('Postal Code is required');
      }

      return schema
        .matches(RegexUtils.postalCodeCountriesRegex[country?.value || country?.code || 'UK'], 'Please enter a valid postcode')
        .required('Please enter a postcode');
    }),
    combined: mixed().notRequired().nullable(),
  }),
};
